<app-modal-container
  [buttons]="modalButtons"
  [title]="'Notifications'"
  (closeButtonClicked)="closeEmitter.emit()"
  (applyButtonClicked)="show.modalAdd=true"
  [spinnerProps]="spinnerProps">

  <div class="selectors-position-absolute centered-row-container position-rel">
    <app-button-drop-down
      data-qa="notifications-select-organization"
      [isCheckBox]="true"
      [data]="selectedOrgList"
      [selectedOrgUuids]="selectedOrgUuids"
      [field]="'name'"
      [buttonType]="'grey'"
      (selectOneEmitter)="selectOne($event)"
      (selectCurrentOrgEmitter)="selectCurrentOrg()"
      (selectAllEmitter)="toggleSelectAll()">
    </app-button-drop-down>

    <app-button-drop-down
      data-qa="notifications-privacy-type"
      [simpleData]="privacyTypes"
      [dropDownWidth]="'width-11'"
      [displayedItem]="privacyType"
      [buttonType]="'grey'"
      (itemEmitter)="filterReminders($event)">
    </app-button-drop-down>
  </div>
  <!--------------------------- TABLE ----------------------------->
  <div class="table-fms" *ngIf="show.table">
    <table>
      <thead>
        <tr>
          <th class="size-xxs"></th>
          <th class="size-xl">Notification</th>
          <th class="size-m">Fund</th>
          <th class="size-m">Created by</th>
          <th class="size-m">Reminder</th>
          <th class="size-m">Deadline</th>
          <th>Status</th>

        </tr>
      </thead>
      <tbody>
        <!--------------------------- PENDING ----------------------------->
        <tr *ngIf="filteredReminders.pending?.length" class="clickable" (click)="show.pending= !show.pending">
          <td>
            <app-table-group-icon [opened]="show.pending"></app-table-group-icon>
          </td>
          <td class="font-4 bold600" colspan="100%">Active</td>
        </tr>
        <ng-container *ngIf="show.pending">
          <tr *ngFor="let r of filteredReminders.pending">
            <td>
              <app-three-dots-menu
                [matMenuTriggerFor]="menu">
              </app-three-dots-menu>
              <mat-menu #menu="matMenu">
                <ul class="list">
               <app-drop-down-item  class="width-100pcnt"
                  data-qa="notifications-edit"
                  [text]="'Edit'"
                  [iconNameAndStyling]="'edit-outline.svg'"
                  (click)="toRequestDto(r); show.modalUpdate=true">
                </app-drop-down-item >

               <app-drop-down-item class="width-100pcnt"
                  data-qa="notifications-delete"
                  [text]="'Delete'"
                  [iconNameAndStyling]="'delete.svg;red-10'"
                  [menuItemClass]="'red'"
                  (click)="showModalDeleteReminder(r)">
              </app-drop-down-item>
                </ul>
              </mat-menu>
            </td>
            <td>
              <div class="row-container row-gap-0p5">
                <div class="start-column-vertically-centered-container">
                  <div class="aligned-row-container row-gap-0p25">
                    <span class="font-4 bold">{{r.topic}}</span>
                    <button *ngIf="r.isPersonal" class="servc-button grey tiny-size no-click">Private</button>
                  </div>
                  <span class="font-4">{{r.description}}</span>
                </div>
              </div>
            </td>
            <td class="font-4">{{r.fund}}</td>
            <td class="font-4">{{r.author}}</td>
            <td >
              <div class="row-container row-gap-0p25">
               <div  class="bg-orange-10 dot mt-0p275"></div>
              <div class="start-column-container">
                <span class="font-4">{{r.reminderDate | date}}</span>
                <span>{{r.daysToReminderStr}}</span>
              </div>
            </div>
            </td>
            <td>
              <div class="row-container row-gap-0p25" *ngIf="r.deadline">
                <div *ngIf="r.daysToDeadline < 0" class="dot bg-red-10 mt-0p275"></div>
              <div class="start-column-container">
                <span class="font-4">{{r.deadline | date}}</span>
                <span>{{r.daysToDeadlineStr}}</span>
              </div>
              </div>
            </td>
            <td>
              <app-button-drop-down-single
                data-qa="notifications-status-active"
                [simpleData]="statusList"
                [additionalClass]="'min-width-6p5'"
                [selectedItem]="r.isCompleted ? 'Completed' : 'Active'"
                [displayedItem]="r.isCompleted ? 'Completed' : 'Active'"
                (itemEmitter)="activeFieldIsTriggered(r)">
              </app-button-drop-down-single>
            </td>
          </tr>
        </ng-container>
        <!--------------------------- COMPLETED ----------------------------->
        <tr *ngIf="filteredReminders.completed?.length" class="clickable" (click)="show.completed=!show.completed">
          <td>
            <app-table-group-icon [opened]="show.completed"></app-table-group-icon>
          </td>
          <td class="font-4 bold600" colspan="100%">Completed</td>
        </tr>
        <ng-container *ngIf="show.completed">
          <tr *ngFor="let r of filteredReminders.completed">
            <td>
              <app-three-dots-menu [matMenuTriggerFor]="menu" [horizontal]="false" >
              </app-three-dots-menu>
              <mat-menu #menu="matMenu">
                <ul class="list">

                  <app-drop-down-item data-qa="edit-reminder"
                    class="width-100pcnt"
                    [text]="'Edit'"
                    [iconNameAndStyling]="'edit-outline.svg'"
                    (click)="toRequestDto(r); show.modalUpdate=true">
                  </app-drop-down-item>

                  <app-drop-down-item data-qa="delete-reminder"
                    class="width-100pcnt"
                    [text]="'Delete'"
                    [iconNameAndStyling]="'delete.svg;red-10'"
                    [menuItemClass]="'red'"
                    (click)="showModalDeleteReminder(r)">
                  </app-drop-down-item>
                </ul>
              </mat-menu>
            </td>
            <td>
              <div class="row-container row-gap-0p5">
                <div class="start-column-vertically-centered-container">
                  <div class="aligned-row-container row-gap-0p25">
                    <span class="font-4 bold">{{r.topic}}</span>
                    <button *ngIf="r.isPersonal" class="servc-button grey tiny-size no-click">Private</button>
                  </div>
                  <span class="font-4">{{r.description}}</span>
                </div>
              </div>
            </td>

            <td class="font-4">{{r.fund}}</td>
            <td class="font-4">{{r.author}}</td>
            <td class="font-4">{{r.reminderDate | date}}</td>
            <td class="font-4" ><span *ngIf="r.deadline"> {{r.deadline | date}}</span></td>
            <td>
              <app-button-drop-down-single
                data-qa="notifications-status-completed"
                [simpleData]="statusListCompleted"
                [additionalClass]="'width-unset'"
                [buttonType]="'grey'"
                [displayedItem]="r.isCompleted ? 'Completed' : 'Active'"
                (itemEmitter)="activeFieldIsTriggered(r)">
            </app-button-drop-down-single>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div class="centered-vertically-column-container no-reminders-wrapper" *ngIf="!show.table">
    <div class="whitespace-medium"></div>
    <app-documents-icon [type]="'full-tray'"></app-documents-icon>
    <div class="whitespace-1p5"></div>
    <span class="font-2 bold600 opacity0p64 text-center">You're all caught up</span>
    <div class="whitespace-0p5"></div>
    <span class="font-3 opacity0p64 text-center">
      When you or someone else from your team creates<br>notification, it will appear here.
    </span>
    <div class="whitespace-medium"></div>
  </div>
</app-modal-container>

<app-notifications-modal-form *ngIf="show.modalAdd"
  [selectedFund]="selectedOrg.selectedFund"
  [isAdminInsideOrg]="isAdminInsideOrg"
  [organizationsWithRole]="organizationsWithRole"
  (closeModal)="show.modalAdd=false"
  (formEmitter)="add($event)">
</app-notifications-modal-form>

<app-notifications-modal-form *ngIf="show.modalUpdate"
  [title]="'Edit notification'"
  [body]="forUpdateBody"
  [isAdminInsideOrg]="isAdminInsideOrg"
  [organizationsWithRole]="organizationsWithRole"
  [selectedFund]="selectedOrg.selectedFund"
  [reminderFundName]="reminderFundName"
  (formEmitter)="update($event)"
  (closeModal)="show.modalUpdate=false">
</app-notifications-modal-form>

<app-modal-dialog *ngIf="show.modalDelete"
  [header]="'Delete reminder'"
  [showInput]="false"
  [mainText]="textListForDeleteReminder"
  (isConfirmed)="closeModalDeleteReminder($event)">
</app-modal-dialog>
